<template>
  <section v-if="ERRORS.length > 0">
    <h1>Errors</h1>
    <ul>
      <li
        v-for="(error, index) in ERRORS"
        :key="index"
        @click="CLEAR_ERROR(index)"
      >
        {{ error }}
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["ERRORS"])
  },
  methods: {
    ...mapMutations(["CLEAR_ERROR"])
  }
};
</script>

<style scoped></style>
